import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet } from '../../api/api_methods';
import { ADMIN_ENDPOINTS } from '../../api/api_endpoints';

// Action
export const fetchGroup = createAsyncThunk('fetchDashboard', async (clusterId) => {
  const id = clusterId;
  const response = await apiGet(`${ADMIN_ENDPOINTS.GROUPS_ALL}?cluster=${id}`);
  console.log(response);
  return response.body;
});

const groupSlice = createSlice({
  name: 'group',
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchGroup.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchGroup.fulfilled, (state, action) => {
      state.isLoading = false;
      console.log(action.payload);

      state.data = action.payload;
    });
    builder.addCase(fetchGroup.rejected, (state, action) => {
      console.log('Error', action.payload);
      state.isError = true;
    });
  },
});

export default groupSlice.reducer;
